import React from 'react';
import { connect } from 'react-redux';
import CircularProgress from 'material-ui/CircularProgress';
import { Headline } from './Text';
import Full from './Full';
import { getCityCrimesPending } from '../reducers/crimes';

const Container = Full.extend`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: pre-line;
  flex-direction: column;
  text-align: center;
`;

export const NoContent = ({ isLoading, children }) => (
  <Container>
    {isLoading ? (
      <CircularProgress />
    ) : (
      <Headline color="grey300">{children}</Headline>
    )}
  </Container>
);

export const NoChart = connect(state => ({
  isLoading: getCityCrimesPending(state),
}))(props => (
  <NoContent {...props}>
    {`No chart available.
      Please select another time interval.`}
  </NoContent>
));

export default NoContent;



// WEBPACK FOOTER //
// ./src/components/NoContent.jsx